import { Card, Row, Form, Col, Button } from 'react-bootstrap';
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import SpAccountManagerDropdown from 'components/dropdowns/SpSalePerson/SpAccountManagerDropdown';

const MyVisitFilter = ({
  handleChange,
  handleSubmit,
  searchKeyword,
  formData,
  style,
  displayOption = {}
}) => {
  const [searchValue, setSearchValue] = useState(searchKeyword);
  useEffect(() => {
    setSearchValue(searchKeyword);
  }, [searchKeyword]);

  return (
    <Card>
      <Card.Body className="bg-light">
        <Row style={style}>
          <Col lg={displayOption.col} style={{ paddingBottom: '10px' }}>
            <Form.Group controlId="eventTitle">
              <Form.Label>Customer Name</Form.Label>
              <Form.Control
                type="text"
                name="keyword"
                placeholder="Customer Name"
                value={formData.keyword ?? searchValue}
                onChange={e => {
                  handleChange('keyword', e.target.value);
                }}
              />
            </Form.Group>
          </Col>
          <Col lg={displayOption.col} style={{ paddingBottom: '10px' }}>
            <Form.Label className="fs-0">Account Manager</Form.Label>
            <SpAccountManagerDropdown
              label="Account Manager"
              placeholder="Account Manager"
              fieldName="saleIds"
              handleChange={(key, value) => handleChange(key, value?.id)}
              // selectedOptions={formData?.saleIds}
            />
          
          </Col>
        </Row>
      </Card.Body>
      {displayOption && displayOption.showFooter && (
        <Card.Footer>
          <hr />
          <div className="text-center mt-2">
            <Button color="primary" onClick={handleSubmit}>
              Search
            </Button>
          </div>
        </Card.Footer>
      )}
    </Card>
  );
};
MyVisitFilter.propTypes = {
  formData: PropTypes.object,
  displayOption: PropTypes.object,
  handleSubmit: PropTypes.func,
  saveConfig: PropTypes.func,
  style: PropTypes.object,
  handleChange: PropTypes.func,
  searchKeyword: PropTypes.string,
  isParentFullRow: PropTypes.bool
};

export default MyVisitFilter;
